import type { FormStepId } from 'shared/config/formStepId';

import type { IOrderedStep, IStepperFormsSet } from '../types';

type TGetStepsFieldsForUpdateParams = {
  steps: IOrderedStep[];
  forms: IStepperFormsSet;
  submittingStepId?: ValuesOf<typeof FormStepId>;
  isFormReady: boolean;
};

export const getStepsFieldsForUpdate = ({
  steps,
  forms,
  submittingStepId,
  isFormReady,
}: TGetStepsFieldsForUpdateParams): Array<ValuesOf<typeof FormStepId>> => {
  if (isFormReady) {
    return steps.map((step) => step.formId);
  }

  if (submittingStepId) {
    return steps
      .filter(({ formId }) => forms[formId]?.isFullFilled || formId === submittingStepId)
      .map((step) => step.formId);
  }

  return steps.filter(({ formId }) => forms[formId]?.isFullFilled).map((step) => step.formId);
};
